import React from 'react';
import './HelpModal.css';
import { FaTimes, FaLightbulb, FaRocket, FaUsers } from 'react-icons/fa';

const HelpModal = ({ isOpen, onClose }) => {
    if (!isOpen) return null;

    return (
        <div className="help-modal-overlay" onClick={onClose}>
            <div className="help-modal-content" onClick={e => e.stopPropagation()}>
                <button className="close-btn" onClick={onClose}>
                    <FaTimes />
                </button>
                
                <div className="modal-header">
                    <h2>What is Mintra?</h2>
                    <div className="underline"></div>
                </div>

                <div className="modal-body">
                    <p className="intro-text">
                        <strong>Mintra</strong> is your ultimate companion for the 42 School curriculum. 
                        Designed by students, for students.
                    </p>

                    <div className="feature-grid">
                        <div className="feature-item">
                            <div className="icon-wrapper">
                                <FaRocket />
                            </div>
                            <div className="feature-text">
                                <h3>Track Progress</h3>
                                <p>Navigate through Common Core projects clearly.</p>
                            </div>
                        </div>
                        
                        <div className="feature-item">
                            <div className="icon-wrapper">
                                <FaLightbulb />
                            </div>
                            <div className="feature-text">
                                <h3>Resources</h3>
                                <p>Access curated guides, tips, and best practices for each project.</p>
                            </div>
                        </div>

                        <div className="feature-item">
                            <div className="icon-wrapper">
                                <FaUsers />
                            </div>
                            <div className="feature-text">
                                <h3>Community</h3>
                                <p>Share feedback and see how others approached the challenges.</p>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className="modal-footer">
                    <button className="got-it-btn" onClick={onClose}>Got it!</button>
                </div>
            </div>
        </div>
    );
};

export default HelpModal;
